export default __webpack_public_path__ + "static/media/3b-mcap-dani.33e4fd32.jpeg";